// extracted by mini-css-extract-plugin
module.exports = {"container_style":"Loading-module__container_style___1y9W8","text_section":"Loading-module__text_section___toIdy"};